import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { Heart, CheckCircle, XCircle, SpinnerGap } from '@phosphor-icons/react';
import { Button } from '../components/ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    
    if (!sessionId) {
      setStatus('error');
      setMessage('Sesiune invalidă');
      return;
    }

    const checkPaymentStatus = async () => {
      try {
        const { data } = await axios.get(
          `${API_URL}/api/payments/status/${sessionId}`,
          { withCredentials: true }
        );

        if (data.payment_status === 'paid') {
          setStatus('success');
          setMessage(data.message || 'Plata a fost procesată cu succes!');
        } else if (data.status === 'open') {
          // Payment still processing, check again
          setTimeout(checkPaymentStatus, 2000);
        } else {
          setStatus('error');
          setMessage('Plata nu a fost finalizată');
        }
      } catch (error) {
        console.error('Payment status error:', error);
        setStatus('error');
        setMessage('Eroare la verificarea plății');
      }
    };

    checkPaymentStatus();
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4" data-testid="payment-success-page">
      <div className="w-full max-w-md text-center space-y-6">
        {/* Logo */}
        <div className="flex items-center justify-center gap-2 text-primary">
          <Heart weight="fill" className="w-10 h-10" />
          <span className="text-2xl font-bold font-[Manrope]">MEDICULDIGITAL</span>
        </div>

        <div className="medical-card p-8">
          {status === 'loading' && (
            <div data-testid="payment-loading">
              <SpinnerGap weight="bold" className="w-16 h-16 text-primary mx-auto mb-4 animate-spin" />
              <h2 className="text-xl font-semibold text-foreground mb-2">
                Se verifică plata...
              </h2>
              <p className="text-muted-foreground">
                Vă rugăm așteptați câteva secunde
              </p>
            </div>
          )}

          {status === 'success' && (
            <div data-testid="payment-success">
              <CheckCircle weight="fill" className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h2 className="text-xl font-semibold text-foreground mb-2">
                Plată reușită!
              </h2>
              <p className="text-muted-foreground mb-6">
                {message}
              </p>
              <Button onClick={() => navigate('/dashboard')} className="w-full">
                Mergi la Dashboard
              </Button>
            </div>
          )}

          {status === 'error' && (
            <div data-testid="payment-error">
              <XCircle weight="fill" className="w-16 h-16 text-destructive mx-auto mb-4" />
              <h2 className="text-xl font-semibold text-foreground mb-2">
                Eroare la plată
              </h2>
              <p className="text-muted-foreground mb-6">
                {message}
              </p>
              <div className="space-y-3">
                <Button onClick={() => navigate('/dashboard')} className="w-full">
                  Încearcă din nou
                </Button>
                <Link 
                  to="/contact" 
                  className="block text-sm text-primary hover:underline"
                >
                  Contactează suportul
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
